import { http } from '@/lib'
import { useAsyncFn } from '@clara/hooks'

import { ReimbursementValues } from './create-reimbursement'

export type UpdateReimbursmentInput = Array<
  Partial<ReimbursementValues & { uuid: string }>
>

export async function updateReimbursement(data: UpdateReimbursmentInput) {
  return http.put('/', data).then((response) => response.data)
}

export function useUpdateReimbursement() {
  return useAsyncFn(async (values: UpdateReimbursmentInput) => {
    const res = await updateReimbursement(values)

    return res
  }, [])
}
